// The following line loads the standalone build of Vue instead of the runtime-only build,
// so you don't have to do: import Vue from 'vue/dist/vue'
// This is done with the browser options. For the config, see package.json
import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
// Only run Sentry.io reporting in the browserified production code, not in the watchified dev server
if (process.env.NODE_ENV === 'production') {
  // Determine whether to label these errors as from staging or production
  let environment
  if (window.location.host.match('staging-app.classicalwalkoffame.net')) {
    environment = 'staging'
  } else if (window.location.host.match('app.classicalwalkoffame.net')) {
    environment = 'production'
  } else {
    environment = 'unknown'
  }
  // Initialize Sentry.io error reporting
  Raven.config('https://4e07d0d068054e6aae21cba4016796a5@sentry.io/142150', {
    release: '0.0.0-30b5a35',
    environment:  environment,
    ignoreUrls: [
      /localhost/,
      /127\.0\.0\.1/,
      /\.codeanyapp\.com/,
    ]
  })
  Raven.addPlugin(RavenVue, Vue)
  Raven.install()
}
// WMH - since this is the entry point and it is a .js file not a .vue file,
// it does NOT get the vueify transforms applied to it. Therefore do as little
// as conceivable here.
var App = require('./app.vue')
App.el = '#app'
const app = new Vue(App) // eslint-disable-line no-new
window.app = app

// TODO: Uncomment this after the old app using the InAppBrowser is gone from app store.
// // Launch the iphone install prompter
// if (window.iPhoneInstallOverlay) {
//   iPhoneInstallOverlay.init({
//     blurElement: '#viewport',
//     appIconURL: './icon/icon-256.png',
//     spritesURL: './iphone-install-overlay/dist/images/mobile-sprite.png',
//     appName: 'Walk of Fame',
//     showOnReload: true,
//     previewText: "I'll install it later →",
//   })
// }